export default __webpack_public_path__ + "static/media/fsk-08-a.5f2c4074.jpg";